const isValidAlertId = (searchVal, matchValue) => {
    // Check if input starts with 'Alert-' and is followed by up to 4 digits
    if (searchVal.toLowerCase().startsWith(matchValue)) {
        const digits = searchVal.slice(matchValue.length);
        return digits.length <= 6 && Number(digits);
    }
    return false;
};
export const inputSearchHandler = (e, setState) => {
    const searchVal = e.target.value;
    const matchValue = 'Alert-'.toLowerCase();

    // Define conditions for when the input is valid
    const isEmptyInput = searchVal === '';
    const isNumericInput = Number(searchVal);
    const matchesPrefix = matchValue[searchVal?.length - 1] === searchVal.toLowerCase()[searchVal?.length - 1];
    const isValidIdFormat =
        matchValue.length <= searchVal.length &&
        Number(searchVal.slice(matchValue.length - 1)) &&
        isValidAlertId(searchVal, matchValue);
    const isValid = matchesPrefix || isEmptyInput || isValidIdFormat || (searchVal.length <= 6 && (isNumericInput || isEmptyInput));
    if (isValid) {
        setState(searchVal);
    }
    return isValid;
}